(function () {
  'use strict';

  angular.module('app.measure')
    .factory('measureService', ['$q', '$http', '$rootScope',
      function ($q, $http, $rootScope) {

        var service = {
            cache: {
                selectedViewReport: '',
                dateRange: {
                    startDate: moment().subtract(1, 'months'),
                    endDate: moment()}
                },
            controllerList: {}
        };

        function checkResponse(data) {
          return data;
        }

        function getMessage(data) {
          if (data) {
            return data.message;
          }
          return false;
        }

        function handleRequest(url, method, params, loader) {
            var deferred = $q.defer();

            var req = {
                url: url,
                method: method,
                data: JSON.stringify(params),
                loader: loader
            } 

            $http(req)
                .success(function (data) {
                var dataRes = angular.fromJson(data);

                if (checkResponse(dataRes)) {
                    deferred.resolve(dataRes);
                } else {
                    deferred.reject(getMessage(dataRes));
                }
            })
                .error(function (result) {
                    deferred.reject(result);
                });

            return deferred.promise;
        }

        function getMeasureReportList(selected_company_id, loader) {
            var url_getMeasureReportList = $rootScope.apiUrl + 'measure/getMeasureReportList?selected_company_id=' + selected_company_id;
            return handleRequest(url_getMeasureReportList, 'GET', null, loader);
        }

        service.getMeasureReportList = getMeasureReportList;

        return service;
    }]);

})();
